import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { space } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import '../Button/index.js';
import '../Heading/index.js';
import { Heading } from '../Heading/Heading.js';
import { Button } from '../Button/Button.js';

const shrinkStyles = (props) => props.shrink &&
    `
    width: 100px;
    white-space: nowrap;
  `;
const TableHeader = styled.thead ``;
const TableBody = styled.tbody ``;
const TableRow = styled.tr ``;
const TableHeading = styled(Heading.H3) `
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  margin: 0;
  ${space};
`;
const TableHeaderCell = styled(({ children, ml, className }) => {
    return (jsx("th", Object.assign({ className: className }, { children: jsx(TableHeading, Object.assign({ ml: ml }, { children: children })) })));
}) `
  width: ${({ width }) => width || 'auto'};
  ${shrinkStyles};
`;
const TableCell = styled.td `
  width: ${({ width }) => width || 'auto'};

  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.foreground.secondary.C};

  ${shrinkStyles};
`;
const TableButton = styled(Button).attrs({
    size: '32',
    variant: 'secondary',
}) ``;
const BaseTableOld = styled.table `
  width: 100%;
  text-align: left;
  border-collapse: collapse;
  table-layout: ${props => (props.fixed ? 'fixed' : 'auto')};

  ${TableHeader}, ${TableRow} {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.A};
    vertical-align: middle;
  }

  ${TableRow /* sc-selector */}:last-child {
    border-bottom: none;
  }

  ${TableHeaderCell /* sc-selector */}, ${TableCell} {
    padding: ${themeGet('space.3')}px 0;
  }
`;
const TableOld = Object.assign(BaseTableOld, {
    Header: TableHeader,
    Body: TableBody,
    Row: TableRow,
    HeaderCell: TableHeaderCell,
    Cell: TableCell,
    Button: TableButton,
});

export { TableOld };
